import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useD3 } from '../../hooks/useD3';
import d3 from '../../utils/d3Importer';
import { partyColours } from '../../utils/functions';
import {
  requestShowToolTip,
  requestHideToolTip,
} from '../../state/actions/createTooltip';

export default function Bubbles() {
  const data = useSelector((state) => state.data.dataRadius);
  const dispatch = useDispatch();

  const wrap = useRef();

  const stageWidth = window.innerWidth > 960 ? 960 : window.innerWidth;

  const margin = { top: 20, right: 0, bottom: 20, left: 0 };
  const fillOpacity = 0.7;

  const ref = useD3(
    (svg) => {
      if (data.length > 0) {
        svg.html('');

        dispatch(requestHideToolTip());

        // do here
        const nestVotes = d3
          .nest()
          .key((d) => d.pa)
          .entries(data);

        const dataNested = {
          key: 'VotesNest',
          values: nestVotes,
        };

        const votesHierarchy = d3
          .hierarchy(dataNested, (d) => d.values)
          .sum((d) => d.vo)
          .sort((a, b) => {
            return b.height - a.height || b.value - a.value;
          });

        const votesPack = d3
          .pack()
          .padding(3)
          .size([
            stageWidth - margin.left - margin.right,
            stageWidth - margin.top - margin.bottom,
          ])(votesHierarchy);

        // eslint-disable-next-line no-unused-vars
        const leaf = svg
          .selectAll('g')
          .data(votesPack.descendants())
          .enter()
          .append('g')
          .attr('transform', (d) => `translate(${d.x + 1},${d.y + 1})`)
          .append('circle')
          .attr('class', (d) => `bubbles ${d.data.bubID}`)
          .attr('r', (d) => {
            return d.r;
          })
          .attr('fill', (d) => {
            if (d.height !== 0) {
              // if you're not a leaf, you don't get a fill
              return '#f8f8f8';
            }
            return partyColours(d.data.pa);
          })
          .attr('fill-opacity', (d) => {
            if (d.height !== 0) {
              // if you're not a leaf, you don't get a fill
              return 1;
            }
            return fillOpacity;
          })
          .style('stroke-width', '1px')
          .style('stroke', (d) => {
            console.log('d ', d);
            if (d.data.key === 'VotesNest') {
              return '#000000';
            }
            if (d.height !== 0) {
              return 'none';
            }
            return partyColours(d.data.pa);
          })
          .on('click', (d) => {
            console.log('data on click ', d);
            const bubs = d3.selectAll('.bubbles');
            bubs.attr('fill-opacity', (w) => {
              if (w.height !== 0) {
                // if you're not a leaf, you don't get a fill
                return 1;
              }
              return fillOpacity;
            });

            if (d.height === 0) {
              const dis = d3.selectAll(`.${d.data.bubID}`);
              dis.attr('fill-opacity', 1);

              dispatch(
                requestShowToolTip({
                  ...d,
                  marginLeft: margin.left,
                  marginRight: margin.right,
                  marginTop: margin.top,
                  marginBottom: margin.bottom,
                  leftBounds: wrap.current.getBoundingClientRect().left,
                  colour: partyColours(d.data.pa),
                }),
              );
            } else {
              dispatch(requestHideToolTip());
            }
          });

        svg
          .selectAll('g')
          .append('text')
          .attr('text-anchor', 'middle')
          .attr('alignment-baseline', 'middle')
          .text((d) => {
            console.log('d ', d);
            if (
              d?.r &&
              d?.r > 25 &&
              d?.data?.la === d?.parent?.children[0]?.data?.la
            ) {
              return d?.data?.pa;
            }
            return '';
          })
          .style('fill', 'white')
          .style('user-select', 'none')
          .style('pointer-events', 'none')
          .style('font-family', 'Raleway')
          .style('font-weight', 700);
      }
    },
    [data],
  );

  const style = {
    width: stageWidth,
    height: stageWidth,
    marginRight: '0px',
    marginLeft: '0px',
  };

  const wrapStyle = {
    display: data.length > 0 ? 'block' : 'none',
  };

  return (
    <section className="content-wrap" ref={wrap} style={wrapStyle}>
      <svg ref={ref} style={style} />
    </section>
  );
}
